import React from 'react';
import { Button } from '@lt/components';

import { useTranslation } from '@lt/localization';
import type { PropsFromRedux } from '.';
import { TEST_ID_ABOUT_ROOM_BTN } from './constants';

type Props = {
  className?: string;
};

const AboutRoomButton = ({
  packageId,
  onClick,
  isHotelOnly,
  hasInfo,
  className,
}: PropsFromRedux & Props) => {
  const { t } = useTranslation();
  if (!hasInfo) return null;
  return (
    <Button
      data-testid={TEST_ID_ABOUT_ROOM_BTN}
      onClick={() => onClick(packageId)}
      type="button"
      className={className}
      functional
    >
      {isHotelOnly
        ? t('hotel.room.facilities_mobile')
        : t('checkout.packageInfo.room.aboutButton')}
    </Button>
  );
};

export default AboutRoomButton;
